export default {
  wrapper: {
    maxWidth: PLATFORM === 'browser' ? '900px' : 'unset',
    margin: '0 auto'
  }
}
